 
jQuery(document).ready(function($) {

    const $navPrev = $('#nav-prev'),
        $navNext = $('#nav-next'),
        $count = parseInt( $("input[name=test-questions-number]").val() ),
        $mainStep1 = $('#main-step-1'),
        $mainStep2 = $('#main-step-2'),
        $answerInput = $('.answer-container>input'),
        warningClass = "warning",
        mainStepActiveclass = "text-default-white",
        mainStepDefaultclass = "text-aqua-100"
        ;
    let
        step = 1,
        stepMax = $count + 2
        ;

    $('.questions-number').html($count);
	

    $navNext.on('click', navNext );

    function navNext() {

        $currentStep = $('#step-' + step);
        // cannot click next if no answer
        if ( $currentStep.hasClass('question') && !$currentStep.find('input:checked').val() ) {
            $currentStep.addClass(warningClass);
            return;
        }
        else {
            $currentStep.removeClass(warningClass);
        }
        $currentStep.addClass('hidden');

        step ++;

        $nextStep = $('#step-' + step)
        $nextStep.removeClass('hidden');

        // on first next nav display previous arrow and go to questions step
        if ( step === 2 ) {
            $navPrev.removeClass('hidden');
            $mainStep1.toggleClass(mainStepActiveclass + ' ' + mainStepDefaultclass);
            $mainStep2.toggleClass(mainStepDefaultclass + ' ' + mainStepActiveclass);
        }

        // end: remove next arrow
        if ( step === stepMax ) {
            $navNext.addClass('hidden');
        }
        
    }


    $navPrev.on('click', function() {

        $currentStep = $('#step-' + step);
        $currentStep.addClass('hidden');

        step --;

        $previousStep = $('#step-' + step);
        $previousStep.removeClass('hidden');

        // start: remove previous arrow
        if (step === 1) {
            $navPrev.addClass('hidden');
            $mainStep1.toggleClass(mainStepDefaultclass + ' ' + mainStepActiveclass);
            $mainStep2.toggleClass(mainStepActiveclass + ' ' + mainStepDefaultclass);
        }

        // end: on return display next nav again
        if ( step === stepMax-1 ) {
            $navNext.removeClass('hidden');
        }
        
    });
    

});